import { GET_INVOICE_SUCCESS_ACTION } from "./action";

const initialState = {
  processing: false,
  error: false,
};

export default function (state: any = initialState, action: Function) {
  switch (action.type) {
    case GET_INVOICE_SUCCESS_ACTION:
      return {
        ...state,
        invoiceList: action.payload.rows,
        invoiceListCount: action.payload.count,
      };
    
    default:
      return {
        ...state,
      };
  }
}
